/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_19365b1d .ms-Suggestions-itemButton{padding:0;border:none}.callout_19365b1d .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_19365b1d";